export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/banner-overlay.a1a7996b-4565eb.png";